export default "__VITE_ASSET__BaEAj6PB__"